import { createStyles, rem } from '@mantine/core'

export interface StylesParams {
  numberItem: number
  blockName: string
}

export default createStyles(
  (theme, { numberItem, blockName }: StylesParams) => {
    return {
      root: {},
      wrapper: {
        position: 'relative',
      },
      shareHeading: {
        fontSize: 10,
      },
      shareArea: {
        position: 'fixed',
        top: '50%',
        right: 0,
        zIndex: 3,
        transform: 'translate(100%, -50%)',
        // opacity: 0,
        transition: 'all 0.3s ease',
        '&.is-show': {
          // opacity: 1,
          transform: 'translate(0, -50%)',
        },
      },
      shareBox: {
        backgroundColor: 'rgba(255,255,255,0.9)',
        backdropFilter: 'blur(8px)',
        borderTopLeftRadius: 8,
        borderBottomLeftRadius: 8,
        padding: '4px 6px',
        gap: 8,
      },
      shareCopyBtn: {
        backgroundColor: 'transparent',
      },
      navigatorWrapper: {
        ...(blockName !== 'ElegantUI' && {
          background: theme.colors.neutral[0],
        }),
      },
      navigatorInner: {},
      navigatorRoot: {
        display: 'flex',
        gap: rem(24),
        ...(blockName === 'FlatIcon'
          ? {
              ...(numberItem > 6
                ? {
                    flexWrap: 'wrap',
                  }
                : {
                    justifyContent: 'center',
                  }),
              [theme.fn.smallerThan('sm')]: {
                flexDirection: 'column',
                gap: rem(8),
              },
            }
          : blockName === 'ElegantUI'
          ? {
              gap: rem(12),
              ...(numberItem > 6
                ? {
                    flexWrap: 'wrap',
                  }
                : {
                    justifyContent: 'center',
                  }),
              [theme.fn.smallerThan('sm')]: {
                flexDirection: 'column',
              },
            }
          : blockName == 'ImageIcon'
          ? {
              [theme.fn.smallerThan('sm')]: {
                flexDirection: 'column',
                gap: rem(8),
              },
            }
          : {}),
      },
      navigatorItem: {
        ...(blockName === 'FlatIcon'
          ? {
              width: '100%',
              flexGrow: 1,
              ...(numberItem > 6 && {
                width: rem(168),
                flexGrow: 0,
              }),
              img: {
                maxWidth: 32,
                maxHeight: 32,
              },
              [theme.fn.smallerThan('sm')]: {
                width: '100%',
              },
              [theme.fn.largerThan('sm')]: {
                gap: rem(12),
              },
            }
          : blockName === 'ImageIcon'
          ? {
              width: '100%',
              flexGrow: 1,
              ...(numberItem > 6 && {
                width: rem(168),
                flexGrow: 0,
              }),
              [theme.fn.largerThan('sm')]: {
                gap: rem(12),
              },
            }
          : blockName === 'ElegantUI'
          ? {
              width: `calc((100% - 36px)/4)`,
              [theme.fn.smallerThan('sm')]: {
                width: '100%',
              },
              img: {
                maxWidth: 48,
                maxHeight: 48,
              },
            }
          : {}),
      },
      navigatorItemImgWrapper: {
        [theme.fn.largerThan('sm')]: {
          width: rem(64),
          height: rem(64),
        },
      },
      navigatorItemTitle: {},
      disclaimer: {
        border: `1px solid ${theme.colors.yellow[1]}`,
        borderRadius: rem(8),
        [theme.fn.smallerThan('sm')]: {
          padding: rem(8),
        },
      },
      disclaimerTitle: { fontWeight: 'normal' },
    }
  },
)
